import { Injectable } from '@angular/core'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

//import { BaseRequestOptions, RequestOptions } from '@angular/http'

import { Observable } from 'rxjs';

@Injectable()
/**
 * Amazon S3 Request
 */
// export class AmazonS3RequestOptions extends BaseRequestOptions {

//     constructor() {
//         super()

//         this.headers.set('enctype', 'multipart/form-data')

//     }

// }

export class AmazonS3RequestOptions implements HttpInterceptor {

    constructor() { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Clone the request to add the new header.
        const authReq = req.clone({ headers: req.headers.set('enctype', 'multipart/form-data') });

        // Pass on the cloned request instead of the original request.
        return next.handle(authReq);
    }
}

//export const amazonS3OptionsProvider = { provide: RequestOptions, useClass: AmazonS3RequestOptions }